import { DataBean } from "../DataBean";

export class QualityErrorTypes extends DataBean {

  public async getQualityErrorTypesCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityErrorTypesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteQualityErrorTypes(idqualityerrortypes: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityErrorTypes_Number", [idqualityerrortypes]);
  }

  public async updateQualityErrorTypes(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityErrorTypes_updateQualityErrorTypes_com.orange.finance.processcontract.bean.QualityErrorTypes",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityErrorTypes",
        },
      ]
    );
  }
}
